// ----
// ref - https://codepen.io/idorenyinudoh/pen/GRjBXER
// ----

document.addEventListener('DOMContentLoaded', () => {
  const audioPlayer = document.querySelectorAll('.mod-audio');

  const calculateTime = (secs) => {
    const hours = Math.floor(secs / 3600);
    const minutes = Math.floor((secs % 3600) / 60);
    const seconds = Math.floor(secs % 60);
    const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    const returnedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;

    if (hours > 0) {
      const returnedHours = hours < 10 ? `0${hours}` : `${hours}`;
      return `${returnedHours}:${returnedMinutes}:${returnedSeconds}`;
    }
    return `${returnedMinutes}:${returnedSeconds}`;
  };

  audioPlayer.forEach((element) => {
    const audioPlayerContainer = element;
    const playIconContainer = element.querySelector('.mod-audio__play');
    const audioElem = element.querySelector('.mod-audio__audio');
    const seekSlider = element.querySelector('.mod-audio__seek-slider');
    const volumeSlider = element.querySelector('.mod-audio__volume-slider-input');
    const volumeButton = element.querySelector('.mod-audio__volume-button');
    const durationContainer = element.querySelector('.mod-audio__time-total');
    const currentTimeContainer = element.querySelector('.mod-audio__time-current');
    const rewindButton = element.querySelector('.mod-audio__rewind');
    const forwardButton = element.querySelector('.mod-audio__forward');
    let raf = null;
    let playState = 'play';
    let muteState = 'unmute';

    const whilePlaying = () => {
      seekSlider.value = Math.floor(audioElem.currentTime);
      currentTimeContainer.textContent = calculateTime(seekSlider.value);
      audioPlayerContainer.style.setProperty('--seek-before-width', `${(seekSlider.value / seekSlider.max) * 100}%`);
      raf = requestAnimationFrame(whilePlaying);
    };

    playIconContainer.addEventListener('click', () => {
      if (playState === 'play') {
        audioElem.play();
        playIconContainer.classList.add('is-playing');
        requestAnimationFrame(whilePlaying);
        playState = 'pause';
      } else {
        audioElem.pause();
        playIconContainer.classList.remove('is-playing');
        cancelAnimationFrame(raf);
        playState = 'play';
      }
    });

    volumeButton.addEventListener('click', (e) => {
      const button = e.currentTarget;
      if (muteState === 'unmute') {
        audioElem.muted = true;
        button.classList.add('is-muted');
        muteState = 'mute';
      } else {
        audioElem.muted = false;
        button.classList.remove('is-muted');
        muteState = 'unmute';
      }
    });

    const showRangeProgress = (rangeInput) => {
      const progress = Math.round((rangeInput.value / rangeInput.max) * 100 * 100) / 100;

      if (rangeInput === seekSlider) audioPlayerContainer.style.setProperty('--seek-before-width', `${progress}%`);
      else audioPlayerContainer.style.setProperty('--volume-before-width', `${progress}%`);
    };

    seekSlider.addEventListener('input', (e) => {
      showRangeProgress(e.target);
    });

    volumeSlider.addEventListener('input', (e) => {
      showRangeProgress(e.target);
    });

    const displayDuration = () => {
      durationContainer.textContent = calculateTime(audioElem.duration);
    };

    const setSliderMax = () => {
      seekSlider.max = Math.floor(audioElem.duration);
    };

    const audioFunctions = () => {
      displayDuration();
      setSliderMax();
    };

    if (audioElem.readyState > 0) {
      audioFunctions();
    } else {
      audioElem.addEventListener('loadedmetadata', () => {
        audioFunctions();
      });
    }

    seekSlider.addEventListener('input', () => {
      currentTimeContainer.textContent = calculateTime(seekSlider.value);
      if (!audioElem.paused) {
        cancelAnimationFrame(raf);
      }
    });

    seekSlider.addEventListener('change', () => {
      audioElem.currentTime = seekSlider.value;
      if (!audioElem.paused) {
        requestAnimationFrame(whilePlaying);
      }
    });

    volumeSlider.addEventListener('input', (e) => {
      const volumeValue = e.target.value;
      audioElem.volume = volumeValue / 100;
      const isMuted = volumeValue <= 0;
      volumeButton.classList.toggle('is-muted', isMuted);
      muteState = isMuted ? 'mute' : 'unmute';
    });

    // Rewind button - move 10 seconds back
    const seekAndPlay = (time) => {
      audioElem.currentTime = time;

      seekSlider.value = Math.floor(audioElem.currentTime);
      currentTimeContainer.textContent = calculateTime(seekSlider.value);

      if (audioElem.paused) {
        audioElem
          .play()
          .then(() => {
            playIconContainer.classList.add('is-playing');
            requestAnimationFrame(whilePlaying);
            playState = 'pause';
          })
          .catch((error) => {
            console.error('Audio playback failed:', error);
          });
      }
    };

    rewindButton.addEventListener('click', () => {
      seekAndPlay(Math.max(0, audioElem.currentTime - 10));
    });

    // Forward button - move 10 seconds forward
    forwardButton.addEventListener('click', () => {
      seekAndPlay(Math.min(audioElem.duration, audioElem.currentTime + 10));
    });

    // When audio ends - remove is-playing and reset
    audioElem.addEventListener('ended', () => {
      playIconContainer.classList.remove('is-playing');
      cancelAnimationFrame(raf);
      playState = 'play';

      audioElem.currentTime = 0;

      seekSlider.value = 0;
      currentTimeContainer.textContent = calculateTime(0);
      audioPlayerContainer.style.setProperty('--seek-before-width', '0%');
    });
  });
});
